import React from "react";

import { withAppState } from "../../../shared/containers/containerAppState";

import FirstTitle from "../../../shared/items/static/firstTitle";
import TitleClosedBarWrapper from "./../../../shared/titleClosedBarWrapper";

const TITLE = "Логистика";

const LogisticTitleClosedBar = (props) => {
  return !props.isSideBarOpen ? (
    <TitleClosedBarWrapper>
      <FirstTitle>{TITLE}</FirstTitle>
    </TitleClosedBarWrapper>
  ) : null;
};

export default withAppState(React.memo(LogisticTitleClosedBar));
